import { render, staticRenderFns } from "./patrolInfo.vue?vue&type=template&id=958addaa&scoped=true&"
import script from "./patrolInfo.vue?vue&type=script&lang=js&"
export * from "./patrolInfo.vue?vue&type=script&lang=js&"
import style0 from "./patrolInfo.vue?vue&type=style&index=0&id=958addaa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958addaa",
  null
  
)

export default component.exports